<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Motivos de transição</h1>
            <p class="welcome-message">
              <button mat-icon-button routerLink="/configuracoes/servicos" aria-label="Voltar">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Motivos apresentados ao mover uma ordem de serviço para uma etapa que exige justificativa.
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button
          mat-stroked-button
          class="btn-secondary btn-spinner"
          [matMenuTriggerFor]="opcoesMenu"
          [class.btn-loading]="isExcluindoSelecionados"
          [disabled]="isExcluindoSelecionados">
          @if (selection.hasValue()) {
            <span>Ações ({{ selection.selected.length }})</span>
          } @else {
            <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          @if (isExcluindoSelecionados) {
            <mat-spinner diameter="20"></mat-spinner>
          }
        </button>
        <mat-menu #opcoesMenu="matMenu">
          <span
            [matTooltip]="tooltipExcluirSelecionados"
            [matTooltipDisabled]="selecionadosExcluiveis.length > 0">
            <button
              mat-menu-item
              (click)="abrirModalExcluir()"
              [disabled]="selecionadosExcluiveis.length === 0">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>
              @if (selection.hasValue()) {
                <span>Excluir selecionados ({{ selection.selected.length }})</span>
              } @else {
                <span>Excluir selecionados</span>
              }
            </button>
          </span>
        </mat-menu>
        <button
          type="button"
          mat-flat-button
          class="btn-primary"
          routerLink="/configuracoes/servicos/motivos-transicao/cadastrar">
          <mat-icon class="material-symbols-outlined">add</mat-icon> Novo motivo
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa" placeholder="Nome do motivo..." />
            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-8 mb-3 mb-md-0 filter-actions">
          <button
            mat-stroked-button
            type="button"
            class="btn-filter"
            [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAvancados"
            [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="model">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros Avançados</h6>
                <div class="filter-menu__form">
                  <mat-form-field appearance="outline">
                    <mat-label>Situação</mat-label>
                    <mat-select formControlName="isAtivo">
                      <mat-option [value]="null">Todas</mat-option>
                      <mat-option [value]="true">Ativo</mat-option>
                      <mat-option [value]="false">Inativo</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="filter-menu__actions">
                <button
                  mat-button
                  type="button"
                  class="btn-secondary"
                  (click)="limparFiltrosAvancados()"
                  matMenuClose>
                  Limpar
                </button>
                <button
                  mat-flat-button
                  type="button"
                  class="btn-primary"
                  (click)="aplicarFiltros()"
                  matMenuClose>
                  Aplicar
                </button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    @if (_isLoading && _dataSource.data.length === 0) {
      <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (_dataSource.data.length > 0) {
      <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="w-checkbox">
            <mat-checkbox
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="w-checkbox">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="nome">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Motivo</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex flex-column">
              <span>{{ element.nome }}</span>
              @if (element.emUso) {
                <small class="motivo-em-uso">em uso no Kanban</small>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="situacao">
          <th mat-header-cell *matHeaderCellDef>Situação</th>
          <td mat-cell *matCellDef="let element">
            <span class="status-badge" [ngClass]="element.isAtivo ? 'badge-verde' : 'badge-cinza'">
              {{ element.isAtivo ? 'Ativo' : 'Inativo' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
          <td mat-cell *matCellDef="let element" class="text-center w-actions">
            <button
              mat-icon-button
              class="btn-spinner"
              [matMenuTriggerFor]="menu"
              aria-label="Ações"
              [class.btn-loading]="idMotivoProcessando === element.idMotivoTransicao"
              [disabled]="idMotivoProcessando === element.idMotivoTransicao">
              <span class="material-symbols-outlined">more_horiz</span>
              @if (idMotivoProcessando === element.idMotivoTransicao) {
                <mat-spinner diameter="18"></mat-spinner>
              }
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                [routerLink]="[
                  '/configuracoes/servicos/motivos-transicao/cadastrar',
                  { idMotivoTransicao: element.idMotivoTransicao },
                ]">
                <span class="material-symbols-outlined">edit</span><span>Editar</span>
              </button>
              <button mat-menu-item (click)="toggleAtivo(element)">
                <span class="material-symbols-outlined">toggle_on</span>
                <span>{{ element.isAtivo ? 'Desativar' : 'Ativar' }}</span>
              </button>
              <span [matTooltip]="element.emUso ? tooltipExclusao(element) : ''">
                <button mat-menu-item (click)="abrirModalExcluir(element)" [disabled]="element.emUso">
                  <span class="material-symbols-outlined">delete</span><span>Excluir</span>
                </button>
              </span>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div class="mobile-view">
        @for (item of _dataSource.data; track item.idMotivoTransicao) {
          <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <mat-checkbox
                  (change)="$event ? selection.toggle(item) : null"
                  [checked]="selection.isSelected(item)"
                  color="primary"></mat-checkbox>
                <div>
                  <span class="text-bold">{{ item.nome }}</span>
                  @if (item.emUso) {
                    <br />
                    <small class="motivo-em-uso">em uso no Kanban</small>
                  }
                </div>
              </div>
              <button
                mat-icon-button
                class="btn-spinner"
                [matMenuTriggerFor]="menuMobile"
                aria-label="Ações"
                [class.btn-loading]="idMotivoProcessando === item.idMotivoTransicao"
                [disabled]="idMotivoProcessando === item.idMotivoTransicao">
                <span class="material-symbols-outlined">more_horiz</span>
                @if (idMotivoProcessando === item.idMotivoTransicao) {
                  <mat-spinner diameter="18"></mat-spinner>
                }
              </button>
              <mat-menu #menuMobile="matMenu">
                <button
                  mat-menu-item
                  [routerLink]="[
                    '/configuracoes/servicos/motivos-transicao/cadastrar',
                    { idMotivoTransicao: item.idMotivoTransicao },
                  ]">
                  Editar
                </button>
                <button mat-menu-item (click)="toggleAtivo(item)">
                  {{ item.isAtivo ? 'Desativar' : 'Ativar' }}
                </button>
                <span [matTooltip]="item.emUso ? tooltipExclusao(item) : ''">
                  <button mat-menu-item (click)="abrirModalExcluir(item)" [disabled]="item.emUso">
                    Excluir
                  </button>
                </span>
              </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
              <span class="status-badge" [ngClass]="item.isAtivo ? 'badge-verde' : 'badge-cinza'">
                {{ item.isAtivo ? 'Ativo' : 'Inativo' }}
              </span>
            </div>
          </div>
        }
      </div>

      <div class="col-12 text-center mt-4 mb-5">
        <button
          mat-button
          class="btn-ver-mais"
          [disabled]="_isLoading || _dataSource.data.length >= _totalRegistros"
          (click)="proximaPagina()">
          @if (_isLoading) {
            <mat-spinner [diameter]="20"></mat-spinner>
          } @else {
            <span class="material-symbols-outlined">expand_more</span> Ver Mais
          }
        </button>
      </div>
    } @else if (_temFiltroAplicado) {
      <app-empty-list
        [title]="'Nenhum motivo encontrado'"
        [subTitle]="'Tente alterar os filtros de busca.'"></app-empty-list>
    } @else {
      <app-empty-list
        [title]="'Nenhum motivo cadastrado'"
        [subTitle]="
          'Cadastre os motivos que aparecerão ao mover uma ordem de serviço para uma etapa que exige justificativa.'
        "></app-empty-list>
    }
  </div>
</div>
